import React from 'react';
import { Clock, X } from 'lucide-react';
import { usePurchase } from '../../context/PurchaseContext';

export function TesterModeBanner() {
  const { testerMode, getTesterExpiryDate, clearTesterMode } = usePurchase();

  if (!testerMode.isActive) return null;

  const expiryDate = getTesterExpiryDate();

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-amber-800 text-sm">
          <Clock className="w-4 h-4" />
          <span>
            <strong>Tester Mode</strong> – expires on {expiryDate}
          </span>
        </div>
        <button
          onClick={() => {
            if (window.confirm('Are you sure you want to exit tester mode? You will need to enter a code or purchase to regain access.')) {
              clearTesterMode();
              window.location.reload();
            }
          }}
          className="text-amber-600 hover:text-amber-800 transition-colors flex items-center gap-1 text-sm"
          data-testid="exit-tester-mode"
        >
          <X className="w-4 h-4" />
          Exit Tester Mode
        </button>
      </div>
    </div>
  );
}
